import { Box, Typography } from "@mui/material";
import logo from "@/../public/img/petcover/logo.png";
import Image from "next/image";
import { InsuranceLeadModal } from "@/app/shared/insurance/InsuranceLeadModal";
import { AdInsuranceModel } from "@/models/AdInsuranceModel";
import Link from "next/link";
import { AdInsurancePromotion } from "./AdInsurancePromotion";

export function AdInsuranceEstimate({
  insurance,
}: {
  insurance: AdInsuranceModel;
}) {
  return (
    <Box>
      <Box
        sx={{
          width: 176,
          display: "flex",
          whiteSpace: "nowrap",
          gap: 2,
          flexDirection: "column",
          border: "1px solid",
          borderColor: "grey.300",
          borderRadius: 2,
          padding: 2,
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Typography
          sx={{
            backgroundColor: "white",
            position: "absolute",
            top: -12,
            left: "50%",
            transform: "translateX(-50%)",
            padding: "2px 6px",
            fontWeight: "bold",
          }}
          variant="caption"
        >
          Insurance
        </Typography>
        <Box
          sx={(theme) => ({
            display: "flex",
            flexDirection: "column",
            gap: 2,
            [theme.breakpoints.down("sm")]: {
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-around",
              flexWrap: "wrap",
            },
          })}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Typography component="span" variant="h6">
              <Typography component="span" variant="caption">
                from
              </Typography>{" "}
              {insurance.monthlyPremium}{" "}
              <Typography component="span" variant="caption">
                / month
              </Typography>
            </Typography>
            <InsuranceLeadModal insurance={insurance} source="AD_ESTIMATE" />
          </Box>

          <AdInsurancePromotion />

          <Box
            component={Link}
            href="/insurance"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Image src={logo} alt="Pet Cover Logo" width={120} />
            <Typography
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
                textAlign: "center",
              }}
              variant="caption"
            >
              learn more
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
